import {defineMessages} from 'react-intl'

export const PASSWORD_MIN_LENGTH = 8

/**
 * Requisitos de contraseña, como descriptores.
 *
 * Vive a nivel de módulo (no hay `intl` aquí), así que se guardan los
 * descriptores y cada consumidor los formatea al pintar:
 *
 *     {PASSWORD_REQUIREMENTS.map((rule) => (
 *       <li key={rule.id}>{intl.formatMessage(rule, {min: PASSWORD_MIN_LENGTH})}</li>
 *     ))}
 *
 * Lo comparten la ficha de usuario (`oneUser/`) y el restablecimiento de
 * contraseña (`authentication/`).
 */
export const PASSWORD_REQUIREMENT_MESSAGES = defineMessages({
  minLength: {
    id: 'validation.password.req.minLength',
    defaultMessage: 'At least {min} characters',
  },
  uppercase: {
    id: 'validation.password.req.uppercase',
    defaultMessage: 'At least one uppercase letter',
  },
  lowercase: {
    id: 'validation.password.req.lowercase',
    defaultMessage: 'At least one lowercase letter',
  },
  number: {id: 'validation.password.req.number', defaultMessage: 'At least one number'},
  special: {
    id: 'validation.password.req.special',
    defaultMessage: 'At least one special character',
  },
})

export const PASSWORD_REQUIREMENTS = [
  PASSWORD_REQUIREMENT_MESSAGES.minLength,
  PASSWORD_REQUIREMENT_MESSAGES.uppercase,
  PASSWORD_REQUIREMENT_MESSAGES.lowercase,
  PASSWORD_REQUIREMENT_MESSAGES.number,
  PASSWORD_REQUIREMENT_MESSAGES.special,
]

/** Mensajes de validación del formulario de contraseña (Yup). */
export const PASSWORD_VALIDATION_MESSAGES = defineMessages({
  minLength: {
    id: 'validation.password.minLength',
    defaultMessage: 'Password must be at least {min} characters',
  },
  uppercase: {
    id: 'validation.password.uppercase',
    defaultMessage: 'Password must contain at least one uppercase letter',
  },
  lowercase: {
    id: 'validation.password.lowercase',
    defaultMessage: 'Password must contain at least one lowercase letter',
  },
  number: {
    id: 'validation.password.number',
    defaultMessage: 'Password must contain at least one number',
  },
  special: {
    id: 'validation.password.special',
    defaultMessage: 'Password must contain at least one special character',
  },
  required: {id: 'validation.password.required', defaultMessage: 'Password is required'},
  match: {id: 'validation.password.match', defaultMessage: 'Passwords must match'},
})
